import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { PublishDate } from '@components/atoms'

const Byline = ({ author, published }) => {
  return (
    <Box
      my={2}
      display="inline-block"
      py={1}
      px={[1, 4, 6]}
      borderColor="grey.light"
      borderBottom="1px solid lightGrey"
      borderTop={1}
      fontSize={[14, 14, 16]}
    >
      {author && <Box mx={1} display="inline-block" data-gtm-author={author}>By {author}</Box>}
      {published && (
        <Box mx={1} display="inline-block" color="grey.dark">
          Published on <PublishDate publishedAt={published} weekday />
        </Box>
      )}
    </Box>
  )
}

Byline.propTypes = {
  /** Author of the article */
  author: PropTypes.string,
  published: PropTypes.string,
}

Byline.defaultProps = {
  author: 'PGA.com',
}

export default Byline
